import { getProfiles } from "@lib/auth/jwt";
import { debugContext } from "@hudson/ui/lib";
import useContent from "@lib/use_content";
import { useContext } from "react";

export default function DebugProfiles(): JSX.Element | null {
  const { debugMode } = useContext(debugContext);
  const { data } = useContent(["couponName"]);

  if (!debugMode) return null;

  const profiles = getProfiles();

  return (
    <div className="flex space-x-8">
      {profiles.user && <p>User: #{profiles.user}</p>}
      {profiles.group && <p>Group: #{profiles.group}</p>}
      {profiles.charter && <p>Charter: #{profiles.charter}</p>}
      {profiles.coupon && (
        <p>
          Coupon: #{profiles.coupon}
          {data?.content?.couponName && ` (${data.content.couponName})`}
        </p>
      )}
      {profiles.sales && <p>Sales: #{profiles.sales}</p>}
    </div>
  );
}
